/* eslint-disable max-len */
import React, { FC } from 'react';
import { AppBundle } from 'api/optimalprint-sdk.d';
import styles from './StudioUspsPremium.module.scss';

export interface StudioUspsPremiumProps {
  usps: AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response.IUsp[];
}

const StudioUspsPremium: FC<StudioUspsPremiumProps> = ({ usps }) => {
  if (!usps) {
    return null;
  }
  return (
    <div className={styles.uspsPremium}>
      {usps.map((usp, index) => (
        <div key={`usp${index}`} className={styles.usp}>
          <div className={styles.icon}>{(usp as any).icon && <img src={(usp as any).icon} alt="" />}</div>
          <div>{usp.text}</div>
        </div>
      ))}
    </div>
  );
};

export default StudioUspsPremium;
